/**
 * Created by jimmy on 2022/7/1.
 */

import React, { useState, useEffect, useRef } from 'react';
import { Progress } from 'antd';
import BraftEditor from 'braft-editor';
import * as REQUEST from "../../common/request";
import ReactSwipe from 'react-swipe';
import * as AMap from '../../../../../common/amap';
import './index.less';

const PageModel = props => {
  let reactSwipeEl = null;
  const [data, setData] = useState(null);
  const [shopCoverIndex, setShopCoverIndex] = useState(0);
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [actity, setActity] = useState(1);

  //两个变量
  const [contentDetail, setContentDetail] = useState('');//富文本展示
  const [voice, setVoice] = useState('');//音频地址

  // 处理播放/暂停
  const togglePlay = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  // 更新进度条和时间
  const updateProgress = () => {
    setCurrentTime(audioRef.current.currentTime);
    if (!duration) setDuration(audioRef.current.duration);
  };

  // 计算剩余时间（格式：MM:SS）
  const formatRemainingTime = () => {
    const remaining = duration - currentTime;
    const minutes = Math.floor(remaining / 60);
    const seconds = Math.floor(remaining % 60);
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  const getData = async () => {
    const { id } = props.match.params;
    const result = await REQUEST.get({
      url: '/zhujiajiao/v2/intro/get',
      data: { id }
    });
    if (!result) return;
    setContentDetail(result.data.intro);//默认展示中文的富文本介绍
    setVoice('https://static-yeekin.oss-cn-shanghai.aliyuncs.com/'+result.data.voice);//默认显示中文音频地址
    setData(result.data);
  };
  useEffect(() => {
    getData();
    return () => false;
  }, [props.match.params]);

  if (!data) return null;

  // const contentDetail = data.intro_jp;
  const editorState = BraftEditor.createEditorState(contentDetail);
  const contentHtml = editorState.toHTML();


  const onselect = (e) => {
    setActity(e);
    setIsPlaying(false);
    if(e == 3){
      setContentDetail(data.intro_jp);//切换到日文富文本介绍
      setVoice('https://static-yeekin.oss-cn-shanghai.aliyuncs.com/'+data.voice_jp);//切换到日文音频地址
    }else if(e == 1){
      setContentDetail(data.intro);//切换到中文富文本介绍
      setVoice('https://static-yeekin.oss-cn-shanghai.aliyuncs.com/'+data.voice);//切换到中文音频地址
    }else if(e == 2){
      setContentDetail(data.intro_en);//切换到英文富文本介绍
      setVoice('https://static-yeekin.oss-cn-shanghai.aliyuncs.com/'+data.voice_en);//切换到英文音频地址
    } else if (e == 4) {
      setContentDetail(data.intro_ka);//切换到韩文富文本介绍
      setVoice('https://static-yeekin.oss-cn-shanghai.aliyuncs.com/' + data.voice_ka);//切换到英文音频地址
    }

  }
  return (
    <section className="h5introdetail-wrapper">
      <div className='h5introdetail-top' style={{ position: 'relative' }}>
        <ReactSwipe
          className="banner"
          swipeOptions={{
            //自动定时播放
            auto: 3000,
            //循环播放
            continuous: true,
            // continuous: false,
            stopPropagation: false,
            transitionEnd: setShopCoverIndex
          }}
          ref={el => (reactSwipeEl = el)}
        >
          {
            data.banner && data.banner.split(',').map((pic, idx) => <div className="banner-item" key={idx} style={{ backgroundImage: `url(${'https://static-yeekin.oss-cn-shanghai.aliyuncs.com/' + pic})` }} />)
          }
        </ReactSwipe>
        {
          data?.banner?.length > 1 && <div className="shop-item-dot">
            {
              data?.banner.split(',').map((citem, cidx) => <em className={cidx == shopCoverIndex ? 'active' : ''} key={cidx} />)
            }
          </div>
        }
      </div>

      <div className='h5introdetail-middle'>
        <div className='h5introdetail-middle-one'>
          <div className='h5introdetail-middle-title'>
            <div className='h5introdetail-middle-title-left'>{data.title}</div>
            <div className='h5introdetail-middle-title-right'>{data.address}</div>
          </div>
          <div className='h5introdetail-middle-img' onClick={async () => {
            const res = await AMap.getCurrentPosition2();
            let startAddress = '';
            let startLngLat = '';
            if (res.formattedAddress && res.lnglat) {
              startAddress = res.formattedAddress;
              startLngLat = res.lnglat.join(',');
            }
            console.log(data.address,data.lng,data.lat);
            let lng = data.lng+','+data.lat;
            const link = `https://gaode.com/dir?from[name]=${startAddress}&from[lnglat]=${startLngLat}&to[name]=${data.address}&to[lnglat]=${lng}&policy=1&type=walk`;
            window.location.href = link;
            return;
          }}>
            <img src={require('./images/daohang4.png')} alt=""></img>
          </div>
        </div>
        <div className='h5introdetail-middle-content'>
          <div className={actity == 1 ? 'h5introdetail-middle-content-title selctactive' : 'h5introdetail-middle-content-title'} onClick={()=>onselect(1)}>中</div>
          <div className={actity == 2 ? 'h5introdetail-middle-content-title selctactive' : 'h5introdetail-middle-content-title'} onClick={()=>onselect(2)}>EN</div>
          <div className={actity == 3 ? 'h5introdetail-middle-content-title selctactive' : 'h5introdetail-middle-content-title'} onClick={()=>onselect(3)}>日</div>
          <div className={actity == 4 ? 'h5introdetail-middle-content-title selctactive' : 'h5introdetail-middle-content-title'} onClick={()=>onselect(4)}>韩</div>
          <div className='h5introdetail-middle-content-title select'>
            {/* 隐藏的 audio 元素 */}
            <audio
              ref={audioRef}
              src={voice}
              onTimeUpdate={updateProgress}
              onLoadedMetadata={() => setDuration(audioRef.current.duration)}
            />

            {/* 进度条 */}
            <Progress
              strokeColor="#734f39"
              percent={(currentTime / duration) * 100 || 0}
              showInfo={false}
            />
            <span>{formatRemainingTime()}</span>
          </div>
          <div className='h5introdetail-middle-content-title selctactives' onClick={togglePlay}>
            {
              isPlaying ? <img src={require('./images/zanting.png')} alt=""></img>
                : <img src={require('./images/bofang.png')} alt=""></img>
            }
          </div>
        </div>
      </div>
      <div className='h5introdetail-bottom'>
        <div className='h5introdetail-bottom-title' dangerouslySetInnerHTML={{ __html: contentHtml }} ></div>
      </div>
      <div className='h5introdetail-bottom-img'>
        <img src={require('./images/bottom.png')} alt="" />
      </div>
    </section>
  );
};

export default PageModel;
